// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defineHorizonElement = (tagName: string, klass: any) => {
  if (!customElements.get(tagName)) {
    customElements.define(tagName, class extends klass {});
  }
};
